
/**
 * Return String RSC Event composed DISCIPLINE+SEX+EVENT
 * 
 * Example: ATHM200M--------------
 *
 * @_rsc : RSC Code  to extract long Event 
 */
export const isTeam = (rsc)  => {
    return (rsc.includes("TEAM"));
}

